import { Box, Tooltip } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { DevicesOther as DevicesOtherIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { sporttiaColors } from '../../theme/theme';

type Props = {
    hasDevice?: boolean;
};

/**
 * Small status icon used in the Estado column of the sc lists (Groups,
 * Bonos, Activities) to flag rows that have at least one device configured.
 * Renders nothing when `hasDevice` is not truthy.
 */
export function SttHasDeviceIcon({
    hasDevice,
}: Props): React.ReactElement | null {
    const { t } = useTranslation();
    if (!hasDevice) {
        return null;
    }
    return (
        <Tooltip title={t('deviceConfigured')}>
            <Box
                aria-label={t('deviceConfigured') as string}
                sx={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: 32,
                    height: 32,
                    borderRadius: '50%',
                    backgroundColor: alpha(sporttiaColors.primary.main, 0.15),
                }}
            >
                <DevicesOtherIcon
                    sx={{ fontSize: 18, color: 'var(--brand-text)' }}
                />
            </Box>
        </Tooltip>
    );
}
